/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function AirplaneTilt(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M215.01538,86.23437l-29.80762,27.98829,30.19824,83.043a8.00184,8.00184,0,0,1-1.86181,8.39161l-24,24A7.99924,7.99924,0,0,1,177.282,228.5127l-42.58691-62.33692-18.80762,17.33106V204a8.0008,8.0008,0,0,1-2.34326,5.65723l-20,20a7.99986,7.99986,0,0,1-13.23291-3.08789L67.38745,188.457l-38.064-12.87891a8.00081,8.00081,0,0,1-3.09326-13.23535l20-20A8.00235,8.00235,0,0,1,51.88745,140H72.574l18.75635-18.75684L27.45,78.65625a8.00073,8.00073,0,0,1-1.21973-12.31348l24-24a8.003,8.003,0,0,1,8.39111-1.86132l83.0625,30.20507,26.606-28.14062a7.98306,7.98306,0,0,1,.97071-1.17383,32.0006,32.0006,0,0,1,47.01806,43.34375A8.03536,8.03536,0,0,1,215.01538,86.23437Z" />
    </Svg>
  );
}

export default AirplaneTilt;
